import { isTaskExecutor, TaskExecutorEnum } from "../../../Enums/TaskExecutors";
import { isTaskStatus, TaskStatusEnum } from "../../../Enums/TaskStatuses";
import { isTaskType, TaskTypeEnum } from "../../../Enums/TaskTypes";
import { isTagResponseDTO, TagResponseApi } from "../Tag/Tag";

export interface TaskDataToCreateResponseApi {
  types: TaskTypeEnum[];
  executors: TaskExecutorEnum[];
  statuses: TaskStatusEnum[];
  tags: TagResponseApi[];
}

export let isTaskDataToCreateResponseDTO = (
  variable: unknown
): variable is TaskDataToCreateResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "types" in variable &&
    Array.isArray(variable.types) &&
    variable.types.reduce(
      (doArrayConsistOfTypes, type: unknown) =>
        doArrayConsistOfTypes && isTaskType(type),
      true
    ) &&
    "executors" in variable &&
    Array.isArray(variable.executors) &&
    variable.executors.reduce(
      (doArrayConsistOfExecutors, executor: unknown) =>
        doArrayConsistOfExecutors && isTaskExecutor(executor),
      true
    ) &&
    "statuses" in variable &&
    Array.isArray(variable.statuses) &&
    variable.statuses.reduce(
      (doArrayConsistOfStatuses, status: unknown) =>
        doArrayConsistOfStatuses && isTaskStatus(status),
      true
    ) &&
    "tags" in variable &&
    Array.isArray(variable.tags) &&
    variable.tags.reduce(
      (doArrayConsistOfTags, tag: unknown) =>
        doArrayConsistOfTags && isTagResponseDTO(tag),
      true
    )
  );
};
